import { useContext } from "react";

import { CurrentUserContext } from "./CurrentUserContext";

export const useCurrentUserContext = () => {
  return useContext(CurrentUserContext);
};

export const useCurrentUser = () => {
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) {
    throw new Error("Current user not found");
  }

  return currentUser;
};
